import styled from 'styled-components';
import { theme, media } from '../../theme';
import bgImage from '../../assets/graphics/bg.jpg';

/**
 * Base container with optional background image
 * Used by all account selector components
 */
export const BaseContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: calc(100svh - ${theme.spacing.controlBarHeight}px);
  color: ${theme.colors.white};
  display: flex;
  justify-content: center;
  padding: 0 0 ${theme.spacing.lg} 0;
  margin: 0;
  box-sizing: border-box;
  background-image: url(${bgImage});
  background-size: cover;
  background-position: center;
  overflow-y: auto;
  overflow-x: hidden;
`;

/**
 * Inner wrapper with max-width constraint
 */
export const BaseInner = styled.div`
  width: 100%;
  max-width: ${theme.sizes.maxContentWidth};
  padding: 40px 0 0 0;
  box-sizing: border-box;

  ${media.tablet} {
    padding: 40px ${theme.spacing.lg} 0 ${theme.spacing.lg};
  }
`;

/**
 * Form title with gold border on the left
 */
export const BaseFormTitle = styled.h1`
  border-left: 2px solid ${theme.colors.gold};
  padding-left: 2rem;
  font-size: ${theme.fontSizes.mega};
  font-weight: ${theme.fontWeights.bold};
  margin-bottom: ${theme.spacing.xxxl};
  color: ${theme.colors.white};

  ${media.desktopLgOrShort} {
    font-size: ${theme.fontSizes.xxxl} !important;
    margin-bottom: ${theme.spacing.md} !important;
  }
`;

/**
 * Account types wrapper with padding
 */
export const BaseAccountTypes = styled.div`
  color: ${theme.colors.white};
  padding: 1rem 1.5rem 3rem 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 2rem;

  ${media.tablet} {
    padding: 0 !important;
  }
`;

/**
 * Grid layout for account cards (3 columns, collapses to 1 on small screens)
 */
export const BaseGrid = styled.div`
  display: grid;
  gap: 3rem;
  grid-template-columns: repeat(3, 1fr);

  ${media.desktopLgOrShort} {
    grid-template-columns: repeat(1, 1fr) !important;
  }
`;

/**
 * Account card with dark theme and hover effects
 */
export const BaseCard = styled.div`
  background-color: ${theme.colors.bgDark};
  border: 1px solid ${theme.colors.gray500};
  padding: 1rem;
  display: flex;
  flex-direction: column;

  &:hover {
    cursor: pointer;
    border: 1px solid ${theme.colors.goldAlt};
    background-color: ${theme.colors.cardBgHover};
  }
`;

/**
 * Shared explore/action button
 */
export const BaseButton = styled.button`
  margin-top: auto;
  background-color: ${theme.colors.goldAlt};
  color: ${theme.colors.black};
  padding: 0.6rem 1rem;
  font-weight: ${theme.fontWeights.semibold};
  border: none;
  border-radius: ${theme.borderRadius.sm};
  cursor: pointer;
  transition: background ${theme.transitions.normal};

  &:hover {
    background-color: #e1bd6c;
  }
`;

/**
 * Feature list with disc bullets
 */
export const BaseFeatureList = styled.ul`
  list-style: disc inside;
  margin-bottom: 1.5rem;
  line-height: ${theme.lineHeights.normal};
  padding: 0;
`;

/**
 * Account image/logo
 */
export const BaseAccountImage = styled.img`
  height: 40px;
  object-fit: contain;
  max-width: 240px;
  width: 90%;
`;
